import axios from 'axios'

const instance = axios.create({
    timeout: 30000,
    headers: { "X-Requested-With": "XMLHttpRequest" },
  });

export default () => ({
    loading: false,
    formSubmitted: false,
    originalButtonLabel: '',
    message: '',
    error: false,
    errors: [],
    success: false,

    init() {
        this.originalButtonLabel = this.$el.dataset.buttonText || 'Verstuur';
        
        if (!this.$el.dataset.buttonText) {
            const submitButton = this.$el.querySelector('button[type="submit"] span');
            if (submitButton && submitButton.textContent) {
                this.originalButtonLabel = submitButton.textContent.trim();
            }
        }
    },

    submit: function(event){
        if (this.formSubmitted) {
            return;
        }
        
        this.loading = true;
        this.error = false;
        this.errors = [];
        const tagHandle = this.$el.dataset.handle
        const successMessage = this.$el.dataset.successMessage || 'Uw bericht is succesvol verstuurd! U ontvangt nog een bevestiging per e-mail.';

        const formData = new FormData(this.$el);
        instance.post(this.$el.action, formData)
            .then(async (response) => {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': tagHandle
                });

                this.message = successMessage;
                this.error = false;
                this.success = true;
                this.formSubmitted = true;
                this.$el.reset();
            })
            .catch((requestError) => {
                const responseData = requestError.response?.data;
                const responseErrors = responseData?.errors || responseData?.error;

                this.error = true;
                this.success = false;
                this.errors = responseErrors
                    ? Object.values(responseErrors)
                        .flatMap((value) => Array.isArray(value) ? value : [value])
                        .filter(Boolean)
                    : ['De aanvraag kon niet worden verstuurd. Probeer het opnieuw of neem contact met ons op.'];
            })
            .finally(() => {
                this.loading = false;
            })
    },
})
